import * as React from 'react';
import './index.css';
import { Transition } from 'react-transition-group';
import { styled } from '@mui/system';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import CloseIcon from '@mui/icons-material/Close';
import { Snackbar } from '@mui/base/Snackbar';
import { SnackbarCloseReason } from '@mui/base/useSnackbar';
import { RED_DARK, GREEN_BASE, GREEN_DARK, GREEN_VERY_DARK } from '../../../assets/Styles';

export default function SnackBarMessage(props: any) {
  const {
    message,
    type = 'success',
    persistent = false,
    onHide } = props;

  const nodeRef = React.useRef(null);

  const [exitedSnackbar, setExitedSnackbar] = React.useState(true);

  const handleClose = (_: any, reason: SnackbarCloseReason | string) => {
    if (reason === 'clickaway') {
      return;
    }

    if (onHide) onHide()
  };

  const handleOnEnter = () => {
    setExitedSnackbar(false);
  };

  const handleOnExited = () => {
    setExitedSnackbar(true);
  };

  return (
    <React.Fragment>
      <StyledSnackbar
        autoHideDuration={!persistent ? 6000 : null}
        open={true}
        onClose={handleClose}
        exited={exitedSnackbar}
      >
        <Transition
          timeout={{ enter: 400, exit: 400 }}
          in={true}
          appear
          unmountOnExit
          onEnter={handleOnEnter}
          onExited={handleOnExited}
          nodeRef={nodeRef}
        >
          {(status) => (
            <SnackbarContent
              className='snackbar-content'
              style={{
                transform: positioningStyles[status],
                transition: 'transform 500ms ease',
                border: `1px solid ${type === 'success' ? GREEN_BASE : RED_DARK}`,
                boxShadow: `0 2px 10px ${type === 'success' ? GREEN_DARK : RED_DARK}`,
              }}
              ref={nodeRef}
            >
              <span 
              className={`snackbar-decoration ${exitedSnackbar ? '' : 'snackbar-decoration-expand'}`}
              style={{ backgroundColor: type === 'success' ? GREEN_BASE : RED_DARK }}
              />
            
              {(type === 'success') &&
                (<CheckRoundedIcon
                  sx={{
                    color: GREEN_DARK,
                    flexShrink: 0,
                    width: '2.0rem',
                    height: '2.5rem',
                  }}
                />
                )}

              {(type === 'error') &&
                (<ErrorOutlineRoundedIcon
                  sx={{
                    color: RED_DARK,
                    flexShrink: 0,
                    width: '2.0rem',
                    height: '2.5rem',
                  }}
                />
                )}

              <div className="snackbar-message">
                {(type === 'success') && (
                  <p className="snackbar-title-success">Acción completada con éxito</p>)
                }
                {(type === 'error') && (
                  <p className="snackbar-title-error">La acción no pudo completarse</p>)
                }
                <p className="snackbar-description">
                  {message}
                </p>
              </div>
              <CloseIcon 
              onClick={(e: any) => handleClose(e, 'close')}
              className={`snackbar-close-icon ${type}`} />
            </SnackbarContent>
          )}
        </Transition>
      </StyledSnackbar>
    </React.Fragment>
  );
}


const StyledSnackbar = styled(Snackbar)`
  position: fixed;
  z-index: 9999;
  display: flex;
  bottom: 16px;
  right: 16px;
  min-width: 300px;
`;

const SnackbarContent = styled('div')(
  ({ theme }) => `
  display: flex;
  position: relative;
  gap: 20px;
  overflow: hidden;
  background-color: white;
  padding: 0.75rem;
  text-align: start;
  position: relative;

  & .snackbar-message {
    flex: 1 1 0%;
    max-width: 100%;
  }

  & .snackbar-title-success {
    margin: 0;
    line-height: 1.5rem;
    margin-right: 0.5rem;
    color: ${GREEN_VERY_DARK};
    font-size: 14px;
    font-weight: 600;
  }

  & .snackbar-title-error {
    margin: 0;
    line-height: 1.5rem;
    margin-right: 0.5rem;
    color: ${RED_DARK};
    font-size: 14px;
    font-weight: 600;

  }

  & .snackbar-description {
    margin: 0;
    line-height: 1.5rem;
    font-size: 14px;
    font-weight: 400;
    color: black;
  }
  `,
);

const positioningStyles = {
  entering: 'translateX(0)',
  entered: 'translateX(0)',
  exiting: 'translateX(500px)',
  exited: 'translateX(500px)',
  unmounted: 'translateX(500px)',
};